import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { decryptEmail } from '../../utils/helpers';
import { postRequest } from '../../Apis';
import { authEndpoints } from '../../utils/constants/httpConstants';
import EventEmitter from '../../utils/emitter/EventEmitter';
import { EMITTER_ERROR, EMITTER_SUCCESS } from '../../utils/constants';
import { FullScreenLoader } from '../../components';
import * as qs from "qs";

const ConnectInboxScreen = () => {

    const payload = useParams();
    const navigate = useNavigate();
    const parsedObject = qs.parse(window.location.search?.slice(1));

    useEffect(() => {
        console.log('parsedObject__', parsedObject);
        (async () => {
            try {

                const decryptedPayload = decryptEmail(payload.payload);
                // DELIBERATE absolute production URL - do NOT "fix" this to
                // authEndpoints.connectInboxVerify. The mailbox connect flow does not
                // work end to end on staging, so this call is pointed at production on
                // purpose to make the flow usable while testing. Changing it back
                // breaks connecting a mailbox on staging entirely.
                const response = await postRequest(navigate, "https://webservicelive.reachiq.ai/auth/api/v2.0/connect-inbox", JSON.parse(decryptedPayload));
                EventEmitter.emit(EMITTER_SUCCESS, response.data.message);
                sessionStorage.setItem('__riq_inbox_just_connected', '1');
                window.dispatchEvent(new CustomEvent('riq:inbox-connected'));

            } catch (error) {
                EventEmitter.emit(EMITTER_ERROR, error.data.message);
            } finally {
                if (parsedObject.tenant_path) {
                    navigate(parsedObject.tenant_path)
                }
            }
        })()
    }, []);

    return <FullScreenLoader />

}

export default ConnectInboxScreen;